import * as React from "react";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="#2195F2"
    />
    <G clipPath="url(#clip0_2895_1663)">
      <Path
        d="M11.1215 4.83381L11.022 12.152H9.86862L9.76919 4.83381H11.1215ZM10.4453 15.0952C10.2001 15.0952 9.98959 15.0073 9.81393 14.8317C9.63827 14.656 9.55044 14.4455 9.55044 14.2003C9.55044 13.955 9.63827 13.7446 9.81393 13.5689C9.98959 13.3932 10.2001 13.3054 10.4453 13.3054C10.6906 13.3054 10.9011 13.3932 11.0767 13.5689C11.2524 13.7446 11.3402 13.955 11.3402 14.2003C11.3402 14.3627 11.2988 14.5118 11.2159 14.6477C11.1364 14.7836 11.0287 14.893 10.8928 14.9759C10.7602 15.0554 10.611 15.0952 10.4453 15.0952Z"
        fill="white"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_2895_1663">
        <Rect
          width={15}
          height={12}
          fill="white"
          transform="translate(2.49646 4)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
